
import { Options, Vue } from "vue-class-component";
import AOS from "aos";

@Options({
  mounted() {
    AOS.init();
  },
})
export default class App extends Vue {
  data() {
    return {
      email: "kounassolazare@gmail.com",
    };
  }
}
